module.exports = __webpack_public_path__ + "static/img/listen.659cac60.png";